module.exports = __webpack_public_path__ + "static/media/hotjobs-africa.282ea9d1.png";